import { Component } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

//INTERFACE
import { EChannelIntegrationStatus } from '../../../channel/interfaces/channel.interface';

//COMPONENT
import { DialogConfig } from '../../../shared/configs/dialog.config';
import { UiMessageDialogComponent } from '../../../ui/components/ui-message-dialog/ui-message-dialog.component';
import { ESalesOrderStatusValue } from '../../interfaces/sales-order.interface';

interface IOrderStatusCellRendererParams extends ICellRendererParams {
  orderStatus :string;
}
@Component({
  selector: 'lum-sales-order-order-status-cell-renderer-component',
  templateUrl: './sales-order-order-status-cell-renderer-component.component.html',
  styleUrls: ['./sales-order-order-status-cell-renderer-component.component.scss'],
})
export class SalesOrderOrderStatusCellRendererComponentComponent
  implements ICellRendererAngularComp
{
  private cellRendererParams :IOrderStatusCellRendererParams;
  constructor(private dialog :MatDialog) {}

  refresh(params :IOrderStatusCellRendererParams) :boolean {
    // Return true to indicate that the cell content has been updated
    return true;
  }

  agInit(params :IOrderStatusCellRendererParams) :void {
    this.cellRendererParams = params;
  }

  private hasShipOrderError(record :IOrderStatusCellRendererParams) :string | null {
    const latestCreatOrderStatus :any =
      record.data.latestShipstationCreateOrderStatus;
    let shipOrderError :string | null = null;
    if (!record.data.shipstationOrderId && latestCreatOrderStatus) {
      shipOrderError = 'Failed to Fulfill Order';
      if (latestCreatOrderStatus.status === EChannelIntegrationStatus.FAILED) {
        try {
          const metadata :any = JSON.parse(latestCreatOrderStatus.metadata);
          if (metadata && metadata.error) {
            shipOrderError += ': ' + metadata.error;
          }
        } catch (e) {}
      }
    }

    return shipOrderError;
  }

  showShipOrderError() :void {
    this.dialog.open(UiMessageDialogComponent, {
      data: {
        title: 'Fulfill Order Error',
        message: this.shipOrderError,
      },
      width: DialogConfig.sizes.small,
    });
  }

  get shipOrderError() :string | null {
    return this.hasShipOrderError(this.cellRendererParams);
  }

  get orderStatusDisplay() :string {
    return this.cellRendererParams.orderStatus;
  }

  get colorClass() :string {
    switch (this.cellRendererParams?.orderStatus) {
      case ESalesOrderStatusValue.AWAITING_SHIPMENT:
        return 'cell-status-circle-yellow';
      case ESalesOrderStatusValue.CANCELLED:
      case ESalesOrderStatusValue.PENDING:
      case ESalesOrderStatusValue.ON_HOLD:
        return 'cell-status-circle-red';
      case ESalesOrderStatusValue.SHIPPED:
        return 'cell-status-circle-green';
      default:
        return '';
    }
  }
}
